'use client';

import { Box } from '@wishket/design-system';

import NewsletterSubscriptionCompleteDialog from '../NewsletterSubscriptionCompleteDialog';

import { useNewsLetterSubscription } from '@/shared/hooks';
import NewsletterSubscriptionButton from '@/features/NewsletterSubscriptionButton';
import NewsletterSubscriptionDialog from '@/features/NewsletterSubscriptionDialog';

interface NewsletterSubscriptionFABProps {
  isVisible: boolean;
}

const NewsletterSubscriptionFAB = ({
  isVisible,
}: NewsletterSubscriptionFABProps) => {
  const {
    isPending,
    information,
    isDialogOpen,
    isCheckBoxError,
    currentOpenModal,
    emailErrorMessage,
    isCompleteDialogOpen,
    onReset,
    onSubmit,
    onChange,
    onClickMore,
    onDialogClose,
    MarketingInfoModal,
    onCompletedDialogClose,
  } = useNewsLetterSubscription();

  const onDialogInit = () => {
    if (isVisible) onReset();
  };

  const emailInputProps = {
    information,
    isCheckBoxError,
    emailErrorMessage,
    onChange,
    onClickMore,
  };

  return (
    <Box className="relative h-fit w-fit">
      <NewsletterSubscriptionButton onClick={onDialogInit} />
      <NewsletterSubscriptionDialog
        isVisible={isVisible}
        isButtonDisabled={isPending}
        emailInputProps={emailInputProps}
        isSubscribeDialogOpen={isDialogOpen}
        isCurrentInfoModalOpen={currentOpenModal}
        onSubmit={onSubmit}
        onClose={onDialogClose}
      />
      <NewsletterSubscriptionCompleteDialog
        email={information.email}
        isOpen={isCompleteDialogOpen}
        onClose={onCompletedDialogClose}
      />
      <MarketingInfoModal isFabVisible={isVisible} />
    </Box>
  );
};

export default NewsletterSubscriptionFAB;
